<template>
  <v-app class="site-layout">
    <SiteNav></SiteNav>
    <v-content class="site-content">
      <!-- <v-row
        align="center"
        justify="center"
        no-gutters
        style="text-align: center;"
      >
        <v-icon left>fa-hard-hat</v-icon>
        <span class="subtitle-1"
          >Site en construction. Pour plus d'informations veuillez contacter
          <a href="mailto:info@geskitchen.com">info@geskitchen.com</a></span
        >
      </v-row> -->
      <transition name="slide-fade">
        <router-view></router-view>
      </transition>
    </v-content>
    <SiteFooter></SiteFooter>
    <ProgressOverlay auth></ProgressOverlay>
  </v-app>
</template>

<script>
import { ProgressOverlay } from "@/modules/Shared";
import { SiteNav, SiteFooter } from "@/modules/Site/components";
export default {
  name: "SiteLayout",
  components: {
    SiteNav,
    SiteFooter,
    ProgressOverlay
  },
  created() {
    this.$vuetify.theme.dark = false;
  },
  data() {
    return {
      showMenu: false
    };
  }
};
</script>

<style scoped>
.site-layout,
.site-content {
  background-color: #ffffff;
}
.slide-fade-enter-active {
  transition: all 1s ease;
}
.slide-fade-leave-active {
  transition: all 0s ease;
}
.slide-fade-enter {
  opacity: 0;
}
.slide-fade-leave-to {
  opacity: 0;
}
</style>
